import axios from "axios";
import { REACT_APP_API_TENANTS_URL } from "../../constants";
import { apiBadRequest, apiServerError } from "../../utils/helpers";

export const fetchAppList = async ({
  payload,
  onSuccess,
  onFailure,
  onError,
}) => {
  try {
    const { data } = await axios.post(
      `${REACT_APP_API_TENANTS_URL}/listApps`,
      payload,

      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );
    if (data.status.toLowerCase() === "success") {
      onSuccess(data.apps);
    }
  } catch ({ response, status }) {
    console.log("code",status);
    
    if (apiBadRequest({ status }))
      return onFailure({ message: "Please Check the API URL" });
    if (apiServerError({ status }))
      return onError({ message: response?.data?.error });
  }
};

export const updateApp = async ({ payload, onSuccess, onFailure, onError }) => {
  try {
    const res = await axios.post(
      `${REACT_APP_API_TENANTS_URL}/updateApps`,
      payload,
    );
    if(res){
        onSuccess(res)
    }
  } catch (status){

  }
};

export const createApp = async ({
  payload,
  onSuccess,
  onFailure,
  onError,
}) => {};
